import { memo, useContext, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ExternalLinkIcon } from 'foundations-assets';
import { INTEGRATIONS_PLATFORM, ZOOM } from '../../types/CallSourceTypes';
import { maybeAddSearchParam } from '../utils/maybeAddSearchParam';
import { MediaElementContext } from '../context/MediaElementContext';
import { jsx as _jsx } from "react/jsx-runtime";
const EXTERNAL_URL_RETRIEVER_REGEX = /(.*)\/recording\/auth\/provider\/hublets\/v1\/external-url-retriever\/getAuthRecording/;
const __RecordingLinkButton = ({
  recordingType = 'default'
}) => {
  const {
    recordingUrl,
    source
  } = useContext(MediaElementContext);
  const isThirdPartyRecording = useMemo(() => {
    return source === ZOOM || source === INTEGRATIONS_PLATFORM;
  }, [source]);

  // https://git.hubteam.com/HubSpot/RecordingAuthProvider/pull/315
  // forceDownload=true bypasses the chunked recording logic
  // which allows browsers to download the audio file.
  const nonChunkedRecordingUrl = useMemo(() => {
    if (isThirdPartyRecording || !recordingUrl || !EXTERNAL_URL_RETRIEVER_REGEX.test(recordingUrl)) {
      return recordingUrl;
    }
    return maybeAddSearchParam(recordingUrl, 'forceDownload', 'true');
  }, [recordingUrl, isThirdPartyRecording]);
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "external-link-button",
    href: nonChunkedRecordingUrl,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: recordingType === 'voicemail' ? 'recordingReviewComponents.recordingLinkButton.tooltipVoicemail' : 'recordingReviewComponents.recordingLinkButton.tooltip'
    }),
    target: "_blank",
    size: "md",
    use: "link",
    children: /*#__PURE__*/_jsx(ExternalLinkIcon, {
      size: "300"
    })
  });
};
export const RecordingLinkButton = /*#__PURE__*/memo(__RecordingLinkButton);